import React from 'react';
import { Link } from 'react-router-dom';
import bigWindowImg from '../pics/spotfreeclarity-bigwindow.PNG';
import solarImg from '../pics/spotfreeclarity-solar2.PNG';
import upladder from '../pics/spotfreeclarity-upladder.PNG';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>✨ Crystal Clear Windows & Solar Panels</h1>
          <p>Professional window cleaning services in Somerset West, South Africa</p>
          <Link to="/contact" className="cta-button">
            Get a Free Quote
          </Link>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <h2>Our Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <img src={bigWindowImg} alt="Ultra-Purified Water System" className="service-image" />
              <h3>💧 Ultra-Purified Water System</h3>
              <p>
                No soap, no chemicals, no residue. Our advanced ultra-purified water system delivers 
                spot-free results instantly. No drying or blading required – just crystal clear windows 
                every time with white-glove precision.
              </p>
            </div>
            <div className="service-card">
              <img src={solarImg} alt="Window and Solar Panel Cleaning" className="service-image" />
              <h3>☀️ Window & Solar Panel Cleaning</h3>
              <p>
                Expert cleaning for residential homes in Somerset West and surrounds. From residential 
                windows to solar panels, we bring yacht-level service standards to your home with 
                meticulous attention to detail.
              </p>
            </div>
            <div className="service-card">
              <img src={upladder} alt="Ultra-Purified Water System" className="service-image" />
              <h3>♻️ Eco-Friendly & Flexible Scheduling</h3>
              <p>
                Sustainable service with zero waste. We recycle wastewater to water gardens, top up pools, 
                or fill jojo tanks. Choose once-off, weekly, bi-weekly, monthly, or custom schedules that 
                work for you. Free no-obligation quotes available.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-us">
        <div className="container">
          <h2>Why Choose Spot Free Clarity?</h2>
          <div className="features-grid">
            <div className="feature">
              <div className="feature-icon">⚡</div>
              <h3>Fast & Efficient</h3>
              <p>Quick turnaround times without compromising on quality</p>
            </div>
            <div className="feature">
              <div className="feature-icon">👨‍💼</div>
              <h3>Professional Team</h3>
              <p>Experienced and trained professionals who take pride in their work</p>
            </div>
            <div className="feature">
              <div className="feature-icon">💰</div>
              <h3>Competitive Pricing</h3>
              <p>Affordable rates with no hidden charges</p>
            </div>
            <div className="feature">
              <div className="feature-icon">✅</div>
              <h3>Quality Assured</h3>
              <p>We guarantee satisfaction with every job</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
